import React from 'react';
import styled from 'styled-components';
import { Header } from '../components/navigation';
import { Body } from '../components/layout/Body';
import { useNavigate } from 'react-router';
import { ROUTES } from '../constants/routes';
import { scrollToTop } from '../utils/usefulFuncs';
import { sendApiRequest } from '../services/api';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

function EconomicImpact() {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    const init = async () => {
      const URL = `v1/genai_doc_search?speaker_query=pow`;
      const { status, data, error } = await sendApiRequest('get', URL);
    };
    init();
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>{/*<DocumentsSnapshotTool onGoBack={onGoBack} />*/}</Body>
    </PageWrapper>
  );
}

export default EconomicImpact;
